<div class="student-play-container">
    <div *ngIf="!quizStarted" class="h-100 w-100 d-flex flex-column gap-5 align-items-center justify-content-center">
        <span *ngIf="teamName" class="team-name text-24-600-166 text-c3">{{teamName}}</span>
        <img width="308" src="assets/icons/person.gif" alt="">
        <p class="text-18-500-150 text-c2 text-center" style="max-width: 30rem;">
            {{"The quiz will start as soon as your teacher begins. Hang tight!" | translate}}
        </p>
    </div>
    <div *ngIf="quizStarted" 
    class="h-100 w-100 overflow-hidden d-flex flex-column gap-5 align-items-center justify-content-center">
    <div  *ngIf="canStartBgAnim" class="w-100 h-100 bg-anim-container d-flex align-items-center justify-content-center overflow-hidden text-center">
            <img  [@rotateScale] class="img-fluid" src="assets/icons/bg-rays.svg" alt="">
        </div>
        <div *ngIf="activeNumber !== null" [@slideUpAnimation] 
        class="text-96-500-83 text-c3 mb-0 position-absolute">
            {{ activeNumber }}
        </div>
    </div>
</div>
